module.exports = __webpack_public_path__ + "static/img/logo.946fb59b.png";